import { Flex, Title, Row, Col } from "@/base/index";
import { SectionPage } from "@/components/section-page";
import { FooterContactsInfo } from "./footer-contacts-info";
import { FooterContactsWebSocial } from "./footer-contacts-web-social";
import { FooterContactsSubscribe } from "./footer-contacts-subscribe";
import { useFooterContactsStyles } from "./footer-contacts.styles";

const ON_CONTACTS_SUBSCRIBE: boolean = false;

export const FooterContacts = () => {
  const { styles } = useFooterContactsStyles();

  return (
    <SectionPage
      classNames={{
        section: styles.section,
        body: styles.body,
      }}
    >
      <Row gutter={[12, 40]}>
        <Col xs={{ flex: "100%" }} lg={{ flex: "50%" }}>
          <Flex vertical gap={20} align="stretch">
            <Title level={5}>Connect with us</Title>

            <Flex vertical gap={16}>
              <FooterContactsInfo />
              <FooterContactsWebSocial />
            </Flex>
          </Flex>
        </Col>

        {ON_CONTACTS_SUBSCRIBE && (
          <Col xs={{ flex: "100%" }} lg={{ flex: "50%" }}>
            <Flex vertical gap={20} align="stretch">
              <Title level={5}>Subscribe to our Newsletter</Title>

              <FooterContactsSubscribe />
            </Flex>
          </Col>
        )}
      </Row>
    </SectionPage>
  );
};
